import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaHome, FaBook, FaHeart, FaMicrophone, FaUser } from 'react-icons/fa';

const navItems = [
  { path: '/app', icon: FaHome, label: 'Home', exact: true },
  { path: '/app/library', icon: FaBook, label: 'Library' },
  { path: '/app/favorites', icon: FaHeart, label: 'Favorites' },
  { path: '/app/voice', icon: FaMicrophone, label: 'Voice' },
  { path: '/app/profile', icon: FaUser, label: 'Profile' },
];

const BottomNavigation = () => {
  const location = useLocation();

  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '8px 0 12px',
      background: 'rgba(11, 29, 58, 0.95)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      zIndex: 1000,
    }}>
      {navItems.map(item => {
        const isActive = item.exact
          ? (location.pathname === item.path || location.pathname === '/app/home')
          : location.pathname === item.path;
        const Icon = item.icon;

        return (
          <NavLink
            key={item.path}
            to={item.path}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 4,
              padding: '8px 16px',
              color: isActive ? '#F5C842' : '#9BAFCC',
              background: isActive ? 'rgba(245, 200, 66, 0.1)' : 'transparent',
              textDecoration: 'none',
              borderRadius: 12,
              transition: 'all 0.2s',
            }}
          >
            <Icon style={{ fontSize: 20 }} />
            <span style={{ fontSize: 11, fontWeight: 600 }}>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default BottomNavigation;
